<template lang="pug">
.options
	.content
		.header
			.title Bezahlung
			.close(@click="cancel") ×
		.frame
			//- iframe(:src="paymentUrl" frameborder="0" sandbox="allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation")
</template>

<script>
import Button from '@/components/Button.vue';

export default {
  components: {
    Button,
  },
  props: ['overlaydata'],
  mounted() {
    window.location.href = this.paymentUrl;
  },
  computed: {
    paymentUrl() {
      return process.env.VUE_APP_API_BASEURL + '/payment/paypal?orderid=' + this.overlaydata.orderId;
    },
  },
  methods: {
    cancel() {
      if (this.overlaydata && this.overlaydata.cancel) this.overlaydata.cancel();
      this.$store.commit('openOverlay', '');
    },
    success() {
      if (this.overlaydata && this.overlaydata.success) this.overlaydata.success();
      this.$store.commit('openOverlay', '');
    },
  },
};
</script>

<style lang="sass" scoped>
.options
	width: 100%
	height: 100vh
	display: flex
	flex-direction: column
	align-items: center
	justify-content: center
	position: fixed
	max-width: 480px
	margin: 0 auto
	right: 0
	top: 0
	left: 0
	z-index: 9
.content
	z-index: 7
	background-color: #fff
	border-radius: 10px
	position: relative
	width: 100%
	height: 100vh
.header
	height: 50px
	display: flex
.title
	font-size: 20px
	color: #1DB2D1
	text-align: center
	align-items: center
	justify-content: center
.close
	position: absolute
	right: 20px
	top: 20px
	background-color: #fff
	z-index: 9
	color: #1DB2D1
	border: 1px solid #1DB2D1
	width: 20px
	height: 20px
	display: flex
	justify-content: center
	align-items: center
	border-radius: 20px
.frame
	border: 0
	height: calc(100vh - 50px)
.description
	text-align: center
	color: #454F63
	margin-top: 20px
.form
	margin-top: 20px
	.field
		display: flex
		flex-direction: column
		& + .field
			margin-top: 20px
		input,
		select
			color: #454F63
			border-radius: 3px
			border: 1px solid #B3BAC8
			padding: 15px 15px 15px 45px
			margin-top: 5px
			background-color: #fff
			font-size: 1rem
			font-family: inherit
			width: 100%
		&-input
			position: relative
			svg
				position: absolute
				bottom: 0
				top: 5px
				left: 20px
				width: 15px
				margin-top: auto
				margin-bottom: auto
	.button
		margin-top: 20px
</style>
